import {
  ActivityIndicator,
  Alert,
  Image,
  ImageBackground,
  Modal,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppIcons } from "../../../assets/images";
import {
  useIsFocused,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { AppTheme } from "../../../utils/theme";
import FastImage from "react-native-fast-image";
import LinearGradient from "react-native-linear-gradient";
import {
  bannerAdKey,
  BASE_URL,
  interstitial,
  playerCountList,
} from "../../../utils/contants";
import Spacer from "../../../components/global/Spacer";
import { ROUTE_NAME } from "../../../utils/routes";
import { useAppSelector } from "../../../redux/storeHook";
import socketService from "../../../services/randomplaySocketService";
import { PERMISSIONS, request, RESULTS } from "react-native-permissions";
import SoundPlayer from "react-native-sound-player";
import { userAction } from "../../../redux/reducers/user";
import { useKeyboardPadding } from "../../../utils/KeyboardPadding";
import { setAppOpenAdPaused } from "../../../utils/useOpenAppAd";
import {
  AdEventType,
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";
const RandomPlayerRoom = () => {
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const [selectedCount, setSelectedCount] = useState<number>(2);
  const { userData } = useAppSelector((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [connecting, setConnecting] = useState(true);
  const { isMusicOn, isPlayMusicOn } = useAppSelector((state) => state.user);
  const isFocused = useIsFocused();
  const keyboardPadding = useKeyboardPadding();

  const bannerRef = useRef<BannerAd>(null);

  useForeground(() => {
    if (Platform.OS === "ios") {
      bannerRef.current?.load();
    }
  });

  const onPress = async () => {
    handleJoinRandom();
  };

  useEffect(() => {
    const unsubscribeLoaded = interstitial.addAdEventListener(
      AdEventType.LOADED,
      () => {
        console.log("@ interstitial ad loaded");
      },
    );
    const unsubscribeOpened = interstitial.addAdEventListener(
      AdEventType.OPENED,
      () => {
        console.log("@ interstitial ad opened");
      },
    );
    const unsubscribeClosed = interstitial.addAdEventListener(
      AdEventType.CLOSED,
      () => {
        console.log("@ interstitial ad closed");
      },
    );
    // interstitial.load();
    return () => {
      unsubscribeLoaded();
      unsubscribeOpened();
      unsubscribeClosed();
    };
  }, []);

  useEffect(() => {
    connectToServer();
    return () => {
      socketService.removeAllListeners();
    };
  }, []);
  useEffect(() => {
    if (isMusicOn && isPlayMusicOn) {
      userAction.setTouchSound(true); // Trigger touch sound on start
      userAction.setMusicPreference(true);
    }
  }, [isFocused]);
  const connectToServer = async () => {
    try {
      setConnecting(true);
      await socketService.connect(BASE_URL);
      setConnecting(false);
      // if (Platform.OS === "android") {
      //   if (interstitial.loaded) {
      //     interstitial.show();
      //   } else {
      //     interstitial.load();
      //   }
      // }
    } catch (error) {
      setConnecting(false);
      // if (interstitial.loaded) {
      //   interstitial.show();
      //   // setAdLoaded(false);
      // } else {
      //   interstitial.load();
      // }
      Alert.alert(
        "Connection Error",
        "Failed to connect to server. Please try again.",
      );
    }
  };
  const requestMicrophonePermission = async () => {
    try {
      const permission =
        Platform.OS === "ios"
          ? PERMISSIONS.IOS.MICROPHONE
          : PERMISSIONS.ANDROID.RECORD_AUDIO;
      let result;
      try {
        setAppOpenAdPaused(true);
        result = await request(permission);
      } finally {
        setAppOpenAdPaused(false, 3000);
      }
      switch (result) {
        case RESULTS.GRANTED:
          return true; // permission allowed
        case RESULTS.BLOCKED:
          console.log("Permission blocked. Open settings.");
          return false;
        case RESULTS.DENIED:
          console.log("Permission denied by user.");
          return false;
        default:
          return false;
      }
    } catch (error) {
      console.log("Permission error:", error);
      return false;
    }
  };
  const handleJoinRandom = async () => {
    if (!userData?.name) {
      Alert.alert("Error", "Please enter your name");
      return;
    }
    if (!userData?._id) {
      Alert.alert("Error", "User ID not found. Please log in again.");
      return;
    }
    setLoading(true);
    try {
      await requestMicrophonePermission();
      const response: any = await socketService.joinRandom(
        userData?.name,
        userData?.profilePicture || "",
        selectedCount,
        userData._id,
        userData?.level,
      );
      setLoading(false);
      // Navigate to waiting room
      navigation.replace(ROUTE_NAME.RandomWaitingRoom, {
        roomId: response?.roomId,
        playerName: userData?.name,
        color: response?.color,
        isHost: true, // Initial as host if created
        userId: userData._id,
        room: response?.room,
      });
    } catch (error) {
      setLoading(false);
      // @ts-ignore
      Alert.alert("Error", error || "Failed to join random match");
    }
  };
  return (
    <ImageBackground
      source={AppIcons.screenBackground}
      style={[styles.mainView, { paddingBottom: keyboardPadding }]}
    >
      <TouchableOpacity
        onPress={() => {
          navigation.goBack();
          userAction.setTouchSound(true);
        }}
        style={styles.backIcon}
      >
        <Image
          source={AppIcons.BackIcon}
          style={{
            width: 50,
            height: 40,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View style={styles.container}>
        <Text style={styles.title}>Play Online</Text>
        <Text style={styles.text}>
          only {userData?.allowedEntryFees} coins to play
        </Text>
        <Spacer size={50} />
        <FastImage
          source={AppIcons.SelectTokenBackground}
          style={styles.selectdeTokenBack}
          resizeMode={FastImage.resizeMode.stretch}
        >
          <Text style={styles.chooseText}>Select Game Mode</Text>
          <View style={styles.playerListView}>
            {playerCountList.map((item) => {
              return (
                <TouchableOpacity
                  activeOpacity={1}
                  onPress={() => {
                    userAction.setTouchSound(true);
                    setSelectedCount(item.numPlayers);
                  }}
                  key={item.id}
                  style={styles.playerItem}
                >
                  <Image source={item.icon} style={styles.playerIcon1} />
                  <Text style={styles.label1}>{item.label}</Text>
                  {item.numPlayers === selectedCount ? (
                    <Image source={AppIcons.TickIcon} style={styles.tick} />
                  ) : (
                    <Image source={AppIcons.UnTickIcon} style={styles.tick} />
                  )}
                </TouchableOpacity>
              );
            })}
          </View>
        </FastImage>
        <TouchableOpacity
          activeOpacity={1}
          style={{ alignSelf: "center", marginTop: 20 }}
          onPress={() => {
            onPress();
          }}
        >
          <LinearGradient
            colors={[
              AppTheme.colors.linearGradient_5,
              AppTheme.colors.linearGradient_6,
            ]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.googleBtn1}
          >
            <LinearGradient
              colors={[
                AppTheme.colors.linearGradient_1,
                AppTheme.colors.linearGradient_2,
              ]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={styles.googleBtn}
            >
              {loading ? (
                <ActivityIndicator
                  size={"large"}
                  color={AppTheme.colors.white}
                />
              ) : (
                <Text style={styles.startText}>FIND MATCH</Text>
              )}
            </LinearGradient>
          </LinearGradient>
        </TouchableOpacity>
      </View>
      <Modal transparent visible={connecting} style={{ flex: 1 }}>
        <View style={styles.modalView}>
          <ActivityIndicator size={"large"} color={AppTheme.colors.white} />
          <Text style={styles.title}>Connecting to server...</Text>
        </View>
      </Modal>
      <View style={styles.botttomView}>
        <BannerAd
          ref={bannerRef}
          unitId={bannerAdKey}
          size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        />
      </View>
    </ImageBackground>
  );
};
export default RandomPlayerRoom;
const styles = StyleSheet.create({
  mainView: {
    flex: 1,
    paddingHorizontal: 16,
  },
  backIcon: {
    position: "absolute",
    top: 70,
    right: 0,
    zIndex: 999,
    elevation: 999,
  },
  container: {
    flex: 1,
    justifyContent: "center",
  },
  title: {
    alignSelf: "center",
    fontSize: 36,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  text: {
    alignSelf: "center",
    fontSize: 20,
    fontFamily: AppTheme.fonts.ALEXANDRIA_SEMIBOLD,
    color: AppTheme.colors.white,
  },
  selectdeTokenBack: {
    width: "100%",
    height: 270,
    alignSelf: "center",
    paddingTop: 20,
  },
  chooseText: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    fontSize: 25,
  },
  playerIcon1: {
    width: 80,
    height: 80,
  },
  label1: {
    fontSize: 20,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  tick: {
    width: 30,
    height: 30,
    marginTop: 10,
  },
  googleBtn: {
    width: 250,
    height: 58,
    borderRadius: 30,
    justifyContent: "center",
  },
  googleBtn1: {
    width: 250,
    height: 65,
    borderRadius: 35,
  },
  startText: {
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 35,
    color: AppTheme.colors.white,
    textAlign: "center",
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  playerListView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
  },
  playerItem: {
    flex: 1,
    marginTop: 15,
    alignItems: "center",
  },
  modalView: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${AppTheme.colors.black}90`,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
});
